import { Button, Modal, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ReusableTable from "../Table";
import useAuditLogModal from "./view/useAuditLogModal";
interface IAuditLogModal {
  handleClose: () => void;
  isModel: boolean;
  modalInfo: { name: string; id: number; subName?: string } | null;
  onAuditAction?: (row: any) => void;
}
const AuditLogModal = ({
  isModel,
  handleClose,
  modalInfo,
  onAuditAction,
}: IAuditLogModal) => {
  const { columns, rows, page, isLoading, onPageChange, metaInfo } =
    useAuditLogModal({ modalInfo, onAuditAction, handleClose });
  return (
    <Modal
      className="!z-[1000000]"
      open={isModel}
      onClose={() => {
        handleClose();
      }}
      style={{ outlineWidth: "0px" }}
      disableAutoFocus={true}
    >
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded bg-white max-h-[40rem]  min-w-[50rem]" style={{ maxWidth: "85rem" }}>
        <div className="flex p-4 justify-between border-b-[1px] border-b-gray-400 bg-gray-200">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="self-end font-bold text-lg text-gray-900"
          >
            {`Audit Log Info about ${modalInfo?.name} ${
              modalInfo?.subName ? `- ${modalInfo?.subName}` : ""
            }`}
          </Typography>
          <Button
            onClick={handleClose}
            variant="outlined"
            className="!border-gray-500 border-2 !p-2 "
          >
            <CloseIcon className="text-gray-500" />
          </Button>
        </div>
        <div className=" m-4 overflow-y-scroll rounded-2xl">
          <ReusableTable
            columns={columns}
            rows={rows}
            page={page}
            loading={isLoading}
            onPageChange={onPageChange}
            totalCount={null}
            perPage={metaInfo?.perPage}
            tableContainerClassName=" max-h-[30rem]"
          />
        </div>
        {/* <div className="flex p-4 justify-between  border-t-[1px] border-t-gray-400 bg-gray-200">
          <Button
            onClick={handleClose}
            variant="outlined"
            className="!border-gray-500 border-2 !p-2 h-8"
          >
            <Typography className="capitalize font-medium text-sm text-gray-500 px-4">
              cancel
            </Typography>
          </Button>
          <Button
            onClick={handleFinish}
            variant="contained"
            className="!border-gray-500 border-2 !p-2 h-8"
            disabled={isFinishButtonDisabled()}
          >
            <Typography className="capitalize font-medium text-sm px-4">
              Finish
            </Typography>
          </Button>
        </div> */}
      </div>
    </Modal>
  );
};

export default AuditLogModal;
